import React from 'react';
import { MagnifyingGlass, X } from '@phosphor-icons/react';

/**
 * Client-side list filter — matches if any key's string value contains query (case-insensitive).
 * Supports dot paths e.g. "reporter.name" and arrays (tags).
 */
export function filterBySearch(items, query, keys) {
  if (!items?.length) return items || [];
  const q = String(query || '').trim().toLowerCase();
  if (!q) return items;

  return items.filter((item) =>
    keys.some((key) => {
      const val = key.split('.').reduce((obj, k) => obj?.[k], item);
      if (val == null) return false;
      if (Array.isArray(val)) {
        return val.some((v) => String(v).toLowerCase().includes(q));
      }
      return String(val).toLowerCase().includes(q);
    }),
  );
}

export default function ListSearch({
  value,
  onChange,
  placeholder = 'Search list…',
  resultCount,
  totalCount,
  style,
  inputStyle,
  maxWidth = '420px',
}) {
  return (
    <div style={{ marginBottom: '6px', ...style }}>
      <div style={{ position: 'relative', maxWidth, width: '100%' }}>
        <MagnifyingGlass
          size={16}
          weight="bold"
          style={{
            position: 'absolute',
            left: '10px',
            top: '50%',
            transform: 'translateY(-50%)',
            color: '#9CA3AF',
            pointerEvents: 'none',
          }}
        />
        <input
          type="search"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          style={{
            width: '100%',
            padding: '6px 28px 6px 32px',
            borderRadius: '6px',
            border: '1px solid #D1D5DB',
            fontSize: '12px',
            boxSizing: 'border-box',
            ...inputStyle,
          }}
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange('')}
            aria-label="Clear search"
            style={{
              position: 'absolute',
              right: '6px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              color: '#9CA3AF',
              padding: '2px',
              display: 'flex',
            }}
          >
            <X size={14} />
          </button>
        )}
      </div>
      {resultCount !== undefined && totalCount !== undefined && (
        <p style={{ fontSize: '11px', color: '#9CA3AF', margin: '4px 0 0' }}>
          Showing {resultCount} of {totalCount}
        </p>
      )}
    </div>
  );
}

/** Common ticket field keys for search */
export const TICKET_SEARCH_KEYS = [
  'ticket_no',
  'subject',
  'domain',
  'status',
  'priority',
  'category',
  'service',
  'reporter.name',
  'reporter.email',
  'reporter.department',
  'domain_fields.product_name',
  'domain_fields.client_name',
  'domain_fields.branch',
  'domain_fields.branch_name',
  'domain_fields.company',
  'assignee_names',
  'description',
  'problem_desc',
];

export const USER_SEARCH_KEYS = ['name', 'email', 'designation', 'role', 'department', 'employee_id'];

export const PRODUCT_SEARCH_KEYS = ['name', 'key', 'description'];

export const ASSET_SEARCH_KEYS = [
  'asset_id', 'asset_tag', 'name', 'asset_type', 'serial_number', 'specs',
  'status', 'assigned_to', 'assigned_to_name', 'brand', 'model', 'location',
  'rdp_host',
];

export const TEAM_MEMBER_SEARCH_KEYS = ['name', 'email', 'designation', 'org_role', 'reports_to_name'];
